import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { ParagraphSentence, IParagraphSentence } from 'app/constants/schemas/ParagraphSentence';
import { Text, IText } from 'app/constants/schemas/Text';
import { MediaGroup, IMediaGroup } from 'app/constants/schemas/MediaGroup';
import { Issue, IIssue } from 'app/constants/schemas/Issue';
import { ParagraphStyle, ParagraphStyleMarshaller } from '../enums/ParagraphStyle';

export interface IParagraph extends IEntity {
  attributes: {
    id: EntityStringId;
    cohortId: string | null;
    paragraphStyle: ParagraphStyle;
  };
  associations: {
    paragraphSentences: IParagraphSentence[];
    leadingMediaGroup: IMediaGroup | null;
    trailingMediaGroup: IMediaGroup | null;
    titleText: IText | null;
    issues: IIssue[];
  };
}

export type Paragraph = Entity<IParagraph>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Paragraph: IEntityType<IParagraph> = vmClient.defineClass({
  typeName: 'Paragraph',
  version: 1,
  persisted: true,
  attributes: {
    cohortId: 'string',
    paragraphStyle: {
      type: ParagraphStyle,
      notNull: true,
      marshaller: ParagraphStyleMarshaller,
    },
  },
  associations: {
    paragraphSentences: [ParagraphSentence],
    leadingMediaGroup: MediaGroup,
    trailingMediaGroup: MediaGroup,
    titleText: Text,
    issues: [Issue],
  },
});
